import React, { useState, useEffect } from "react";
import './Serdetails.css';
import { BASE_URL } from '../../../Components/Base_url/Base_Url';
import Loader from '../../../Components/Base_url/Loader';

function Service_details_cards({ detail, DetailsLoading }) {

    const [BusService, setBusService] = useState([]);
    const [BusServiceloading, setBusServiceLoading] = useState(true);

    useEffect(() => {
        fetch(`${BASE_URL}/service_master_home/?segment_id=3`)
            .then((res) => res.json())
            .then((data) => {
                setBusService(data.data || []);
                setBusServiceLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching services:", err);
                setBusServiceLoading(false);
            });
    }, []);

    if (BusServiceloading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-50">
                <Loader show={BusServiceloading} />
            </div>
        );
    }



    return (
        <>
            <div className="S_D-service-details-page">
                {
                    DetailsLoading ? (
                        <div className="d-flex justify-content-center align-items-center w-10 vh-10">
                            <Loader show={DetailsLoading} />
                        </div>
                    ) : (
                        <section className="S_D-service-section">

                            <div className="S_D-service-intro">
                                <div className="S_D-intro-image-container">
                                    <img
                                        src={`${BASE_URL}/${detail.img}`}
                                        alt={detail.name} className="S_D-intro-image" />
                                    <div className="S_D-intro-image-overlay">
                                        <h3>{detail.name}</h3>
                                        <p>Your reliable transport partner</p>
                                    </div>
                                </div>
                                <div className="S_D-intro-text">
                                    <h5>{detail.name}</h5>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: detail.description }}
                                        className="m-0 p-0"
                                    />
                                </div>
                                {detail?.Paragraph && (
                                    <div className="S_D-service-info">
                                        <p
                                            className="d-block"
                                            dangerouslySetInnerHTML={{ __html: detail.Paragraph }}
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Features Section */}
                            {/* <div className="S_D-features-section">
                                <div className="S_D-section-header">
                                    <h3 className="S_D-section-title">Features & Benefits</h3>
                                    <p className="S_D-section-subtitle">
                                        We offer safety-first rides, easy booking, and driver verification.
                                        Choose what suits you best.
                                    </p>
                                </div>

                                <div className="S_D-features-grid">
                                    {[
                                        { icon: "fas fa-clock", title: "24/7 Availability", desc: "Book rides any time — day or night." },
                                        { icon: "fas fa-shield-alt", title: "Safety First", desc: "Regularly-maintained vehicles and verified drivers." },
                                        { icon: "fas fa-wallet", title: "Transparent Pricing", desc: "No hidden fees — pay exactly what you see." },
                                        { icon: "fas fa-route", title: "Flexible Routes", desc: "Customize stops and routes on demand." },
                                        { icon: "fas fa-user-tie", title: "Professional Drivers", desc: "Trained drivers for a smooth experience." },
                                        { icon: "fas fa-mobile-alt", title: "Easy Booking", desc: "Book online or call — fast confirmations." },
                                    ].map((feature, i) => (
                                        <div key={i} className="S_D-feature-card">
                                            <div className="S_D-feature-icon">
                                                <i className={feature.icon}></i>
                                            </div>
                                            <div className="S_D-feature-title">{feature.title}</div>
                                            <div className="S_D-feature-description">{feature.desc}</div>
                                        </div>
                                    ))}
                                </div>
                            </div> */}

                            {/* Vehicle Section */}

                        </section>
                    )
                }

                {/* BUS Section */}
                <section className="S_D-service-section S_D-bus-section">
                    <div className="S_D-section-header">
                        <h2 className="S_D-section-title">Bus Services</h2>
                        <p className="S_D-section-subtitle">
                            We provide comfortable bus services for groups, school trips,
                            corporate outings, and long-distance routes. Choose from AC / Non-AC
                            / Volvo options with driver & helper.
                        </p>
                    </div>

                    <div className="S_D-vehicle-grid">
                        {BusService.map((bus, index) => (
                            <div key={index} className="S_D-vehicle-card">

                                <div className="S_D-vehicle-image">
                                    <img
                                        src={bus.img ? `${BASE_URL}${bus.img}` : "/placeholder-bus.png"}
                                        alt="{bus.name}"
                                    />
                                    <div className="S_D-vehicle-overlay">
                                        <button className="S_D-vehicle-btn" data-service="Mini Bus">
                                            Book Now
                                        </button>
                                    </div>
                                </div>
                                <div className="S_D-vehicle-details">
                                    <h4 className="S_D-vehicle-title">{bus.name}</h4>
                                    <p className="S_D-vehicle-description">
                                        {bus.Paragraph}
                                    </p>
                                    <div className="S_D-vehicle-price">From ₹6,999/day</div>
                                </div>
                            </div>
                        ))}

                    </div>
                </section>

                {/* Tour Packages */}
                <section className="S_D-service-section S_D-tour-section">
                    <div className="S_D-section-header">
                        <h2 className="S_D-section-title">Tour Packages</h2>
                        <p className="S_D-section-subtitle">
                            Pre-made and customizable tour packages — weekend getaways, heritage
                            tours, and adventure trips. Packages include transport, hotel
                            options, and local guides.
                        </p>
                    </div>

                    <div className="S_D-tour-grid">
                        {[
                            {
                                title: "Weekend Hill Package",
                                desc: "2 nights / 3 days — transport + stay + local sightseeing.",
                            },
                            {
                                title: "Cultural Heritage Package",
                                desc: "Guided heritage tours with local experts & comfortable travel.",
                            },
                        ].map((pkg, i) => (
                            <div key={i} className="S_D-tour-card">
                                <div className="S_D-tour-content">
                                    <h4>{pkg.title}</h4>
                                    <p>{pkg.desc}</p>
                                    <button className="S_D-tour-btn">
                                        Book Now
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* vichaless */}
                {/* <div className="S_D-vehicle-section">
                    <div className="S_D-section-header">
                        <h3 className="S_D-section-title">Vehicle Options</h3>
                        <p className="S_D-section-subtitle">
                            Pick the vehicle that fits your group and luggage.
                        </p>
                    </div>

                    <div className="S_D-vehicle-grid">
                        {[
                            {
                                img: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=1350&q=80",
                                title: "Standard Sedan",
                                desc: "Comfort for up to 4 passengers.",
                                price: "From ₹1,499",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=1350&q=80",
                                title: "Premium Sedan",
                                desc: "Luxury ride for business and comfort.",
                                price: "From ₹2,299",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1549924231-f129b911e442?auto=format&fit=crop&w=1350&q=80",
                                title: "SUV",
                                desc: "Roomy for up to 6 passengers + luggage.",
                                price: "From ₹3,499",
                            },
                        ].map((vehicle, i) => (
                            <div key={i} className="S_D-vehicle-card">
                                <div className="S_D-vehicle-image">
                                    <img src={vehicle.img} alt={vehicle.title} />
                                    <div className="S_D-vehicle-overlay">
                                        <button className="S_D-vehicle-btn" data-service={vehicle.title}>
                                            Book Now
                                        </button>
                                    </div>
                                </div>
                                <div className="S_D-vehicle-details">
                                    <h4 className="S_D-vehicle-title">{vehicle.title}</h4>
                                    <p className="S_D-vehicle-description">{vehicle.desc}</p>
                                    <div className="S_D-vehicle-price">{vehicle.price}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> */}

                {/* Booking Process */}
                <section className="S_D-service-section S_D-booking-process">
                    <div className="S_D-section-header">
                        <h3 className="S_D-section-title">How to Book</h3>
                        <p className="S_D-section-subtitle">
                            Quick steps to reserve your ride or vehicle
                        </p>
                    </div>

                    <div className="S_D-process-steps">
                        {[
                            { num: 1, title: "Choose Service", desc: "Select the vehicle or package you want." },
                            { num: 2, title: "Book Online", desc: "Fill details & preferences in the booking form." },
                            { num: 3, title: "Confirmation", desc: "Receive booking confirmation & driver info." },
                            { num: 4, title: "Enjoy Ride", desc: "Safe and comfortable travel — we've got you covered." },
                        ].map((step) => (
                            <div key={step.num} className="S_D-process-step">
                                <div className="S_D-step-number">{step.num}</div>
                                <h4 className="S_D-step-title">{step.title}</h4>
                                <p className="S_D-step-description">{step.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>
            </div >
        </>
    )
}

export default Service_details_cards
